import { put, takeEvery } from "redux-saga/effects";
import { fetchGraphMethod, fetchMethod } from "../../services/httpService";
import messagePopup from "../../utils/messagePopup";

// ========================================== Action Type =====================================================
export const actionType = {
    SAT_MATH_LIST_START: "SAT_MATH_LIST_START",
    SAT_MATH_LIST_SUCCESS: "SAT_MATH_LIST_SUCCESS",
    SAT_MATH_LIST_FAILED: "SAT_MATH_LIST_FAILED",
};

// ============================================ Actions ========================================================
export const satMathListStart = (data) => ({
    type: actionType.SAT_MATH_LIST_START,
    payload: data,
});

export const satMathListSuccess = (data) => ({
    type: actionType.SAT_MATH_LIST_SUCCESS,
    payload: data,
});

export const satMathListFailed = (data) => ({
    type: actionType.SAT_MATH_LIST_FAILED,
    payload: data,
});

// =========================================== Reducer ===========================================================
const INIT_STATE = {
    loading: false,
    data: null,
    error: null,
};

export default function satMathListReducer(state = INIT_STATE, action) {
    switch (action.type) {
        case actionType.SAT_MATH_LIST_START:
            return {
                ...state,
                loading: true,
            };
        case actionType.SAT_MATH_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload,
                error: null,
            };
        case actionType.SAT_MATH_LIST_FAILED:
            return {
                ...state,
                loading: false,
                data: null,
                error: action.payload,
            };
        default:
            return { ...state };
    }
}

// ===================================================== side effect =============================================

export function* satMathListSaga(action) {
    try {
        const response = yield fetchGraphMethod(action.payload.query, action.payload.variables, true);
        if (response && response.status === 200) {
            const allSatMath =  response.data.data.allSatmaths.Satmaths
            yield put(satMathListSuccess(allSatMath));
        } else {
            messagePopup("", "Sat Math List failed", "error");
            yield put(satMathListFailed("Sat Math List failed"));
        }
    } catch (error) {
        messagePopup("", "Sat Math failed", "error");
        yield put(satMathListFailed("Sat Math List failed"));
    }
}

export function* watchSatMathListSaga() {
    yield takeEvery(actionType.SAT_MATH_LIST_START, satMathListSaga);
}
